import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaClipboard, FaUsers, FaFileAlt, FaFileSignature, FaFileContract } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'react-bootstrap';

const TrainingCampaigns = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const goToTrainingReports= () => {
    navigate('/TrainingReports');
  };
  const goToCampaignUsersSummary= () => {
    navigate('/CampaignUsersSummary');
  };
  const goToTrainingcampaignprogress= () => {
    navigate('/Trainingcampaignsprogress');
  };
  return (
    <div className="container my-4 p-4">
      
      <div className="d-flex justify-content-between align-items-center mb-3">
      <h1 className="mb-4 textAwareness">{t("TrainingReports")}</h1>
  <Button
    variant="primary"
    className="mb-3"
    onClick={() => navigate(-1)}
  >
    {t('Back')}
  </Button>
</div>



      <div className="row g-4">
        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaClipboard /></div>
              <h6 className="card-title mt-3">{t("TrainingCampaignSummaryDashboard")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToTrainingReports}>{t('View')}</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaUsers /></div>
              <h6 className="card-title mt-3">{t("Campaignuserssummarydashboard")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToCampaignUsersSummary}>{t('View')}</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaFileAlt /></div>
              <h6 className="card-title mt-3">{t("Trainingcampaignsprogressdashboard")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToTrainingcampaignprogress}>{t('View')}</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaClipboard /></div>
              <h6 className="card-title mt-3">{t("SurveyCampaignSummaryDashboard")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToTrainingReports}>{t('View')}</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaFileSignature /></div>
              <h6 className="card-title mt-3">{t("SurveySummaryDashboard")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToTrainingReports}>{t('View')}</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaFileContract /></div>
              <h6 className="card-title mt-3">{t("PolicyCampaignSummaryDashboard")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToTrainingReports}>{t('View')}</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm h-100">
            <div className="card-body d-flex flex-column align-items-center">
              <div style={{ fontSize: '2.5rem', color: '#6c757d' }}><FaFileAlt /></div>
              <h6 className="card-title mt-3">{t("LessonsCampaignPolicyReport")}</h6>
              <button className="btn btn-primary mt-3" onClick={goToTrainingReports}>{t('View')}</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TrainingCampaigns;
